import {  useNavigate} from "react-router-dom";
import { ReactComponent as SuccesssIocn } from "../../Asset/promptIcon.svg";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import "./passsuccess.css";

const PassswordResetSuccess = () => {
   
  const navigate = useNavigate();

 

  return (
    <div className="pass-success-container">
      <div className="content-card">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <div className="content">
          <SuccesssIocn />
          <h3>Successful</h3>
          <p>
            Your password has been reset successfully. return to log into your
            account
          </p>
          <button onClick={() => navigate("/Login")}>Log in</button>
        </div>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default PassswordResetSuccess;
